import axios from "axios";
import { setupCache } from "axios-cache-adapter";

const cache = setupCache({
  maxAge: 15 * 60 * 1000,
});

const pokeApiAxios = axios.create({
  adapter: cache.adapter,
});

import * as Types from "./types";
import * as Utils from "./utils";

const PokeApi = {
  Types,
  Utils,
};

export { pokeApiAxios, PokeApi };
